import BannerList from '_modules/banner/views/BannerList.vue';
import BannerPage from '_modules/banner/views/BannerPage.vue';
import Banners from './Root.vue';

export default {
  path: 'banner',
  name: 'banners',
  component: Banners,
  redirect: '/banner/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-banner-list',
      component: BannerList,
    },
    {
      path: 'novo',
      name: 'admin-banner-new',
      component: BannerPage,
    },
    {
      path: ':bannerId',
      name: 'admin-banner-edit',
      component: BannerPage,
    },
  ],
};
